import { Action } from 'redux';

import { FetchPrivateConnectionsRequest, FetchPrivateConnectionsRequestSucceeded } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';

import { IPrivateConnectionInfo } from '../models/PrivateConnectModels';

export interface FetchPrivateConnectionsRequestAction extends Action {}

export function fetchPrivateConnectionsRequest(): FetchPrivateConnectionsRequestAction {
  return {
    type: FetchPrivateConnectionsRequest
  };
}

export const isFetchPrivateConnectionsRequest = isActionFactory<FetchPrivateConnectionsRequestAction>(FetchPrivateConnectionsRequest);

export interface FetchPrivateConnectionsRequestSucceededAction extends Action {
    readonly privateConnections: IPrivateConnectionInfo[];
  }

  export function fetchPrivateConnectionsRequestSucceeded(privateConnections: IPrivateConnectionInfo[]): FetchPrivateConnectionsRequestSucceededAction {
    return {
      type: FetchPrivateConnectionsRequestSucceeded,
      privateConnections
    };
  }

  export const isFetchPrivateConnectionsRequestSucceeded = isActionFactory<FetchPrivateConnectionsRequestSucceededAction>(FetchPrivateConnectionsRequestSucceeded);